import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap"
import { Component, Input } from "@angular/core"

@Component({
    selector: "app-notification-modal",
    templateUrl: "./notification-modal.component.html",
    styleUrls: ["./notification-modal.component.less"],
})
export class NotificationModalComponent {
    @Input() message: string

    constructor(public activeModal: NgbActiveModal) {}
}
